import { Box, Paper } from "@mui/material";
import React from "react";

export default function PoliticaPertoTeachers() {
  return (
    <div
      className="terms-wrapper p-20"
      style={{ fontFamily: "Heebo , sans-serif" }}
    >
      <h2 style={{ margin: 20 }}>
        Política de Privacidade - Aplicativo Perto Teachers
      </h2>

      <Box style={{ margin: 20 }} sx={{ flexGrow: 1 }}>
        <Paper sx={{ p: 2 }}>
          <h4 style={{ marginTop: 10, marginBottom: 10 }}>
            Conteúdo do Aplicativo
          </h4>
          <p style={{ paddingLeft: "2.5rem", fontSize: "1rem" }}>
            O aplicativo Perto Teachers, desenvolvido pela equipe de tecnologia
            da Perto Educação, tem como objetivo conectar os profissionais das
            escolas parceiras aos conteúdos digitais produzidos pela Perto
            Educação. Todo o material veiculado no aplicativo é de propriedade
            intelectual da Perto Educação e apresenta conteúdo próprio para
            todas as idades, respeitando todas as crenças, etnias e ideologias.
          </p>
          <br />

          <h4 style={{ marginTop: 10, marginBottom: 10 }}>Dados Pessoais</h4>
          <p style={{ paddingLeft: "2.5rem", fontSize: "1rem" }}>
            Para utilizar o aplicativo é necessário que o usuário crie uma conta
            informando obrigatoriamente os seguintes dados: Nome completo, CPF e
            endereço de email. Tais dados são utilizados para fins cadastrais e
            determinar o funcionamento do aplicativo. A Perto Educação
            compromete-se a resguardar todos os dados pessoais de seus usuários,
            coletando-os sempre de maneira transparente e mantendo-os em
            conformidade com a Lei da Proteção de Dados Pessoais de 26 de
            outubro de 1998 (Lei nº 67/98).
            <br />
            <br />O aplicativo não coleta e não possui acesso a dados do usuário
            e de terceiros armazenados no dispositivo, acessando apenas os
            recursos necessários para o correto funcionamento em conformidade
            com os sistemas operacionais Android e iOS. Não é necessário que o
            usuário revele mais informações pessoais, além das já solicitadas
            previamente no cadastro, para participar das atividades. Os usuários
            tem liberdade para rever as informações pessoais coletadas por este
            aplicativo e, caso suspeitem de mau uso dos dados, podem a qualquer
            momento solicitar a suspensão do acesso e remoção da conta.
          </p>

          <br />
          <h4 style={{ marginTop: 10, marginBottom: 10 }}>
            Anúncios, monitoramento e terceiros
          </h4>
          <p style={{ paddingLeft: "2.5rem", fontSize: "1rem" }}>
            O aplicativo Perto Teachers não trabalha com anúncios e não realiza
            coleta de dados para tal. Todos os dados fornecidos são utilizados
            unicamente para definir a experiência no ambiente do aplicativo.
            <br />
            <br />
            Os dados fornecidos ao aplicativo não serão utilizados para
            direcionar qualquer tipo de anúncio ou campanha em outras mídias,
            bem como não serão compartilhados com terceiros.
          </p>
          <br />

          <h4 style={{ marginTop: 10, marginBottom: 10 }}>Público Alvo</h4>
          <p style={{ paddingLeft: "2.5rem", fontSize: "1rem" }}>
            Para complementar o cadastro do profissional é solicitada uma chave
            de acesso a ser disponibilizada pela escola onde o profissional
            atua. Esta escola deve ser parceira da Perto Educação e ter suas
            informações devidamente cadastradas no banco de dados. Desta forma,
            o aplicativo Perto Teachers não é aberto ao público geral, tendo
            como público alvo profissionais das escolas parceiras da Perto
            Educação e funcionando com o objetivo de complementar a relação
            entre a equipe da Perto Educação e os profissionais das escolas
            parceiras.
          </p>
          <br />
          <h4 style={{ marginTop: 10, marginBottom: 10 }}>
            Sobre a Perto Educação
          </h4>
          <p style={{ paddingLeft: "2.5rem", fontSize: "1rem" }}>
            A Perto Educação tem como objetivo implementar ensino bilíngue em
            suas escolas parceiras inserindo a língua inglesa no ensino de forma
            lúdica e divertida na rotina dos alunos, utilizando a estrutura
            física e os profissionais que já fazem parte da escola e estrutura
            virtual na forma de aplicativo para professores, equipe pedagógica,
            alunos e família.
          </p>
          <br />

          <h4 style={{ marginTop: 10, marginBottom: 10 }}>Contato</h4>
          <p style={{ paddingLeft: "2.5rem", fontSize: "1rem" }}>
            Website:{" "}
            <a target="_blank" href="https://pertoeducacao.com/">
              pertoeducacao.com
            </a>
            <br />
            Email: <b>contato@pertobilingue.com</b>
            <br />
            Telefone/WhatsApp: <b>(41) 3329-6778</b>
            <br />
            <br />
            Atendimento de segunda a sexta, das 9h às 17h
          </p>
        </Paper>
      </Box>
    </div>
  );
}
